module.exports = "../images/timberlane-lodge-logo@2x.png?v=242bd02";